import { render, staticRenderFns } from "./ExchangeIcon.vue?vue&type=template&id=5db58d30&"
import script from "./ExchangeIcon.vue?vue&type=script&lang=js&"
export * from "./ExchangeIcon.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports